import { useMsal } from "@azure/msal-react";
import { useState, useEffect } from "react";

interface LoggedUser {
  username: string;
  userId: string;
  name: string;
  email: string;
  role: string;
}

const useLoggedUser = (): LoggedUser | null => {
  const { accounts } = useMsal();
  const [loggedUser, setLoggedUser] = useState<LoggedUser | null>(null);

  useEffect(() => {
    if (!accounts?.length) return;

    const account = accounts[0];
    const { username, idTokenClaims } = account;

    const userData: LoggedUser = {
      username,
      userId: (idTokenClaims?.extension_ilpuid as string) || "",
      email:
        (idTokenClaims?.email as string) ||
        (idTokenClaims?.preferred_username as string) ||
        username,
      role: (idTokenClaims?.extension_ilpr as string) || "",
      name: (idTokenClaims?.name as string) || "",
    };

    setLoggedUser((prev) =>
      JSON.stringify(prev) !== JSON.stringify(userData) ? userData : prev
    );
    
  }, [accounts]);

  return loggedUser;
};

export default useLoggedUser;
